<div
  class="input-field"
  [ngClass]="{
    'has-value': internalFormControl.value !== undefined,
    'has-column-layout': layoutDirection !== 'row'
  }"
>
  <label
    class="input-label field-label"
    [ngClass]="{
      'sr-text': hideLabel,
      disabled: formControl?.disabled
    }"
    [attr.for]="fieldId"
    type="text"
  >
    {{ label }}
  </label>

  <div class="input-wrapper">
    <input
      class="input"
      i2gInput
      [ngClass]="{ invalid: formControl?.dirty && formControl?.invalid }"
      [attr.data-e2e-id]="e2eId"
      [i2gFocusable]="focusableTrigger$"
      tabindex="0"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
      [i2gFormatAsNumber]="formatAsNumberOptions"
      type="text"
      [attr.id]="fieldId"
      [value]="initialValue"
      [formControl]="internalFormControl"
      i2gTrackable
      [trackingObject]="trackingObject"
      [trackingAction]="trackingAction"
      (blur)="inputBlur.emit()"
      (focus)="inputFocus.emit()"
    />

    <i2g-error-message
      [dirty]="formControl.dirty"
      [invalid]="formControl.invalid"
      [errorMessage]="errorMessage"
    >
    </i2g-error-message>
  </div>
</div>
